import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimeline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.53826 5.16667C6.53826 6.26 5.88849 7.2 4.95506 7.61V9.43333H11.2878V7.61C10.3544 7.2 9.70465 6.26 9.70465 5.16667C9.70465 3.69333 10.8854 2.5 12.3433 2.5C13.8012 2.5 14.982 3.69333 14.982 5.16667C14.982 6.26 14.3322 7.2 13.3988 7.61V9.43333H16.0374V8.36667C16.0374 8.04333 16.2287 7.75 16.5256 7.62667C16.8224 7.50333 17.1622 7.57 17.3897 7.8L19.5007 9.93333C19.8107 10.2467 19.8107 10.7533 19.5007 11.0633L17.3897 13.1967C17.1622 13.4267 16.8224 13.4933 16.5256 13.37C16.2287 13.2467 16.0374 12.9567 16.0374 12.6333V11.5667H9.17692V13.39C10.1103 13.8 10.7601 14.74 10.7601 15.8333C10.7601 17.3067 9.57931 18.5 8.12145 18.5C6.66359 18.5 5.48279 17.3067 5.48279 15.8333C5.48279 14.74 6.13256 13.8 7.06599 13.39V11.5667H1.78867C1.20486 11.5667 0.733204 11.09 0.733204 10.5C0.733204 9.91 1.20486 9.43333 1.78867 9.43333H2.84413V7.61C1.91071 7.2 1.26094 6.26 1.26094 5.16667C1.26094 3.69333 2.44174 2.5 3.8996 2.5C5.35746 2.5 6.53826 3.69333 6.53826 5.16667Z",
		fill: "#0D2976"
	})
});
export default SvgTimeline;
